// UN SELETTORE DI FILE SENZA UN CAMPO A SCHERMO. Lo slot di un asset ha i propri comandi —
// «scegli», «sostituisci» — e il campo file del browser non somiglia a nessuno dei due: si crea al
// volo, si apre, e se ne va. Stava scritto dentro le texture d'ambiente; ora lo usano anche le
// mappe di un materiale, e due copie dello stesso gesto divergerebbero alla prima correzione.
//
// PIÙ FILE INSIEME, perché così arrivano le sei facce di una cube map.
export const pickFiles = (accept: string, onPicked: (files: FileList) => void) => {
    const input = document.createElement('input');
    input.setAttribute('multiple', 'multiple');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', accept);
    input.addEventListener('change', (event) => {
        const files = (event.currentTarget as HTMLInputElement).files;
        if (files && files.length > 0) onPicked(files);
    });

    document.body.appendChild(input);
    input.click();
    document.body.removeChild(input);
};
